import { createAction, handleActions } from 'redux-actions';
import produce from 'immer';
import { takeLatest, select } from 'redux-saga/effects';
import * as diagnosisAPI from '../lib/api/diagnosis';
import createRequestSaga, {
  createRequestActionTypes,
} from '../lib/createRequestSaga';

//TODO: file remove
// Action Type 정의
const [
  GET_ALL_DIAGNOSIS_HISTORY,
  GET_ALL_DIAGNOSIS_HISTORY_SUCCESS,
  GET_ALL_DIAGNOSIS_HISTORY_FAILURE,
] = createRequestActionTypes('diagnosis/GET_ALL_DIAGNOSIS_HISTORY');
const [
  GET_FOREHEAD_RESULT,
  GET_FOREHEAD_RESULT_SUCCESS,
  GET_FOREHEAD_RESULT_FAILURE,
] = createRequestActionTypes('diagnosis/GET_FOREHEAD_RESULT');
const [
  GET_FOREHEAD_RESULT_RECENT,
  GET_FOREHEAD_RESULT_RECENT_SUCCESS,
  GET_FOREHEAD_RESULT_RECENT_FAILURE,
] = createRequestActionTypes('diagnosis/GET_FOREHEAD_RESULT_RECENT');
const [
  GET_FOREHEAD_HISTORY,
  GET_FOREHEAD_HISTORY_SUCCESS,
  GET_FOREHEAD_HISTORY_FAILURE,
] = createRequestActionTypes('diagnosis/GET_FOREHEAD_HISTORY');
const [
  GET_MORE_FOREHEAD_HISTORY,
  GET_MORE_FOREHEAD_HISTORY_SUCCESS,
  GET_MORE_FOREHEAD_HISTORY_FAILURE,
] = createRequestActionTypes('diagnosis/GET_MORE_FOREHEAD_HISTORY');
const [
  DELETE_FOREHEAD_RESULT,
  DELETE_FOREHEAD_RESULT_SUCCESS,
  DELETE_FOREHEAD_RESULT_FAILURE,
] = createRequestActionTypes('diagnosis/DELETE_FOREHEAD_RESULT');
const [
  UPDATE_FOREHEAD_RESULT,
  UPDATE_FOREHEAD_RESULT_SUCCESS,
  UPDATE_FOREHEAD_RESULT_FAILURE,
] = createRequestActionTypes('diagnosis/UPDATE_FOREHEAD_RESULT');

const [
  GET_FOREHEAD_RANK,
  GET_FOREHEAD_RANK_SUCCESS,
  GET_FOREHEAD_RANK_FAILURE,
] = createRequestActionTypes('diagnosis/GET_FOREHEAD_RANK');

const [
  MAKE_FOREHEAD_SHARE_ID,
  MAKE_FOREHEAD_SHARE_ID_SUCCESS,
  MAKE_FOREHEAD_SHARE_ID_FAILURE,
] = createRequestActionTypes('diagnosis/MAKE_FOREHEAD_SHARE_ID');

const [
  MAKE_SIMULATION_SHARE_ID,
  MAKE_SIMULATION_SHARE_ID_SUCCESS,
  MAKE_SIMULATION_SHARE_ID_FAILURE,
] = createRequestActionTypes('diagnosis/MAKE_SIMULATION_SHARE_ID');

const INIT_FOREHEAD_SHARE_ID = 'diagnosis/INIT_FOREHEAD_SHARE_ID';
const INIT_HISTORY = 'diagnosis/INIT_HISTORY';

const [
  GET_FOREHEAD_CHALLENGE,
  GET_FOREHEAD_CHALLENGE_SUCCESS,
  GET_FOREHEAD_CHALLENGE_FAILURE,
] = createRequestActionTypes('diagnosis/GET_FOREHEAD_CHALLENGE');

// Action 생성
export const getAllDiagnosisHistory = createAction(
  GET_ALL_DIAGNOSIS_HISTORY,
  ({ user_id }) => ({ user_id }),
);
export const getForeheadResult = createAction(
  GET_FOREHEAD_RESULT,
  ({ user_id, diagnosis_id }) => ({ user_id, diagnosis_id }),
);
export const getForeheadResultRecent = createAction(
  GET_FOREHEAD_RESULT_RECENT,
  ({ user_id }) => ({ user_id }),
);
export const getForeheadHistory = createAction(
  GET_FOREHEAD_HISTORY,
  ({ user_id, skip, take }) => ({ user_id, skip, take }),
);
export const getMoreForeheadHistory = createAction(
  GET_MORE_FOREHEAD_HISTORY,
  ({ user_id, skip, take }) => ({ user_id, skip, take }),
);
export const deleteForeheadResult = createAction(
  DELETE_FOREHEAD_RESULT,
  ({ user_id, diagnosis_id, skip, take }) => ({
    user_id,
    diagnosis_id,
    skip,
    take,
  }),
);
export const updateForeheadResult = createAction(
  UPDATE_FOREHEAD_RESULT,
  ({
    user_id,
    diagnosis_id,
    forehead_area,
    forehead_area_ratio,
    forehead_area_score,
    final_subscore_forhead_man,
    final_subscore_forhead_woman,
    final_subscore_length,
    final_subscore_young,
    final_subscore_shape,
    final_total_score_man,
    final_total_score_woman,
  }) => ({
    user_id,
    diagnosis_id,
    forehead_area,
    forehead_area_ratio,
    forehead_area_score,
    final_subscore_forhead_man,
    final_subscore_forhead_woman,
    final_subscore_length,
    final_subscore_young,
    final_subscore_shape,
    final_total_score_man,
    final_total_score_woman,
  }),
);
export const getForeheadRank = createAction(
  GET_FOREHEAD_RANK,
  ({ user_id, diagnosis_id }) => ({ user_id, diagnosis_id }),
);
export const makeForeheadShareId = createAction(
  MAKE_FOREHEAD_SHARE_ID,
  ({ user_id, diagnosis_id, data }) => ({
    user_id,
    diagnosis_id,
    data,
  }),
);

export const makeSimulationShareId = createAction(
  MAKE_SIMULATION_SHARE_ID,
  ({ user_id, diagnosis_id, data }) => ({
    user_id,
    diagnosis_id,
    data,
  }),
);

export const initForeheadShareId = createAction(
  INIT_FOREHEAD_SHARE_ID,
  (data) => data,
);
export const initHistory = createAction(INIT_HISTORY, () => {});

export const getForeheadChallenge = createAction(
  GET_FOREHEAD_CHALLENGE,
  ({ user_id }) => ({ user_id }),
);

// saga 생성
export const getAllDiagnosisHistorySaga = createRequestSaga(
  GET_ALL_DIAGNOSIS_HISTORY,
  diagnosisAPI.getAllDiagnosisHistory,
);
export const getForeheadResultSaga = createRequestSaga(
  GET_FOREHEAD_RESULT,
  diagnosisAPI.getForeheadResult,
);
export const getForeheadResultRecentSaga = createRequestSaga(
  GET_FOREHEAD_RESULT_RECENT,
  diagnosisAPI.getForeheadResultRecent,
);
export const getForeheadHistorySaga = createRequestSaga(
  GET_FOREHEAD_HISTORY,
  diagnosisAPI.getForeheadHistory,
);
export const getMoreForeheadHistorySaga = createRequestSaga(
  GET_MORE_FOREHEAD_HISTORY,
  diagnosisAPI.getForeheadHistory,
);

export const deleteForeheadResultSaga = createRequestSaga(
  DELETE_FOREHEAD_RESULT,
  diagnosisAPI.deleteForeheadResult,
);
export const updateForeheadResultSaga = createRequestSaga(
  UPDATE_FOREHEAD_RESULT,
  diagnosisAPI.updateForeheadResult,
);
export const getForeheadRankSaga = createRequestSaga(
  GET_FOREHEAD_RANK,
  diagnosisAPI.getForeheadRank,
);
export const makeForeheadShareIdSaga = createRequestSaga(
  MAKE_FOREHEAD_SHARE_ID,
  diagnosisAPI.makeForeheadShareId,
);
export const makeSimulationShareIdSaga = createRequestSaga(
  MAKE_SIMULATION_SHARE_ID,
  diagnosisAPI.makeSimulationShareId,
);

function* enterForeheadChallenge() {
  const m_diagnosis_type = yield select(
    (state) => state.diagnosis.foreheadResult.type,
  );

  if (m_diagnosis_type === 'FOREHEAD_CHALLENGE') {
    const m_diagnosis_id = yield select(
      (state) => state.diagnosis.foreheadResult.m_diagnosis_id,
    );
    const user_id = yield select((state) => state.user.users[0].user_id);

    diagnosisAPI.enterForeheadChallenge({
      user_id: user_id,
      data: { m_diagnosis_id: m_diagnosis_id },
    });
  }
}

export const getForeheadChallengeSaga = createRequestSaga(
  GET_FOREHEAD_CHALLENGE,
  diagnosisAPI.getForeheadChallenge,
);

export function* diagnosisSaga() {
  yield takeLatest(GET_ALL_DIAGNOSIS_HISTORY, getAllDiagnosisHistorySaga);
  yield takeLatest(GET_FOREHEAD_RESULT, getForeheadResultSaga);
  yield takeLatest(GET_FOREHEAD_RESULT_RECENT, getForeheadResultRecentSaga);
  yield takeLatest(GET_FOREHEAD_HISTORY, getForeheadHistorySaga);
  yield takeLatest(GET_MORE_FOREHEAD_HISTORY, getMoreForeheadHistorySaga);
  yield takeLatest(DELETE_FOREHEAD_RESULT, deleteForeheadResultSaga);
  yield takeLatest(GET_FOREHEAD_RANK, getForeheadRankSaga);
  yield takeLatest(MAKE_FOREHEAD_SHARE_ID, makeForeheadShareIdSaga);
  yield takeLatest(MAKE_SIMULATION_SHARE_ID, makeSimulationShareIdSaga);
  yield takeLatest(UPDATE_FOREHEAD_RESULT, updateForeheadResultSaga);
  yield takeLatest(UPDATE_FOREHEAD_RESULT_SUCCESS, enterForeheadChallenge);
  yield takeLatest(GET_FOREHEAD_CHALLENGE, getForeheadChallengeSaga);
  yield takeLatest(DELETE_FOREHEAD_RESULT_SUCCESS, () => window.history.back());
}

const initialState = {
  allData: [],
  foreheadHistory: null,
  historyItems: null,
  historySize: 0,
  foreheadRecent: null,
  foreheadResult: null,
  latestInfo: null,
  currentRanking: null,
  shareResult: null,
  error: null,
  foreheadChallenge: null,
};

export default handleActions(
  {
    // 통합 진단 내역들 결과 불러오기 성공
    [GET_ALL_DIAGNOSIS_HISTORY_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      allData: result.diagnoses,
    }),
    // 통합 진단 내역들 결과 불러오기 실패
    [GET_ALL_DIAGNOSIS_HISTORY_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),
    // 단일 이마비율 정보 불러오기 성공
    [GET_FOREHEAD_RESULT_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      foreheadResult: result,
    }),
    // 단일 이마비율 정보 불러오기 실패
    [GET_FOREHEAD_RESULT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),
    // 최신 이마비율 정보 불러오기 성공
    [GET_FOREHEAD_RESULT_RECENT_SUCCESS]: (state, { payload: result }) => {
      // console.group('GET_FOREHEAD_RESULT_RECENT_SUCCESS');
      // console.log(JSON.stringify(result.recent.m_diagnosis_id));
      // console.groupEnd();
      return {
        ...state,
        foreheadRecent: result.recent,
      };
    },
    // 최신 이마비율 정보 불러오기 실패
    [GET_FOREHEAD_RESULT_RECENT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),
    // 히스토리 이마비율 정보 불러오기 성공
    [GET_FOREHEAD_HISTORY_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      foreheadHistory: result,
      historyItems: result.items,
      historySize: result.take,
    }),
    // 히스토리 이마비율 정보 불러오기 실패
    [GET_FOREHEAD_HISTORY_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),
    // 히스토리 이마비율 정보 더 불러오기 성공
    [GET_MORE_FOREHEAD_HISTORY_SUCCESS]: (state, { payload: result }) => {
      const newItems = [...state.historyItems, ...result.items];
      const newSize = state.historySize + result.take;

      return {
        ...state,
        foreheadHistory: result,
        historyItems: newItems,
        historySize: newSize,
        latestInfo: { ...state.latestInfo, history_idx: state.historySize - 1 },
      };
    },
    // 히스토리 이마비율 정보 더 불러오기 실패
    [GET_MORE_FOREHEAD_HISTORY_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),
    // 단일 이마비율 정보 삭제하기 성공
    [DELETE_FOREHEAD_RESULT_SUCCESS]: (state, { payload: result }) => {
      let newItems = [];
      const newSize = result.take;
      result.items.map((item, idx) => {
        return newItems.push(item);
      });
      return {
        ...state,
        foreheadHistory: result,
        historyItems: newItems,
        historySize: newSize,
      };
    },
    // 단일 이마비율 정보 삭제하기 실패
    [DELETE_FOREHEAD_RESULT_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),
    // m진단내의 이마면적, 비율, 점수, 종합 점수(남/여) 정보 수정하기성공
    [UPDATE_FOREHEAD_RESULT_SUCCESS]: (state, { payload: result }) => {
      // console.group('UPDATE_FOREHEAD_RESULT_SUCCESS');
      // console.log(JSON.stringify(result));
      // console.groupEnd();
      return {
        ...state,
        currentRanking: result.rank,
        foreheadResult: result.diagnosis,
      };
    },
    // m진단내의 이마면적, 비율, 점수, 종합 점수(남/여) 정보 수정하기 실패
    [UPDATE_FOREHEAD_RESULT_FAILURE]: (state, { payload: error }) => {
      return {
        ...state,
        checkError: error,
      };
    },
    // 진단 내역의 이마면적 랭킹 정보 불러오기 성공
    [GET_FOREHEAD_RANK_SUCCESS]: (state, { payload: result }) => {
      return {
        ...state,
        currentRanking: result.rank,
        foreheadResult: result.diagnosis,
      };
    },
    // 진단 내역의 이마면적 랭킹 정보 불러오기 실패
    [GET_FOREHEAD_RANK_FAILURE]: (state, { payload: error }) => {
      console.log('DIAGNOSIS GET_FOREHEAD_RANK_FAILURE!!!@@@' + error);
      return {
        ...state,
        checkError: error,
      };
    },

    // 얼굴 분석 이미지 공유를 위한 share Id 생성 하기 성공
    [MAKE_FOREHEAD_SHARE_ID_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      shareResult: result,
    }),
    // 얼굴 분석 이미지 공유를 위한 share Id 생성 하기 실패
    [MAKE_FOREHEAD_SHARE_ID_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),

    // 시뮬레이션 이미지 공유를 위한 share Id 생성 하기 성공
    [MAKE_SIMULATION_SHARE_ID_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      shareResult: result,
    }),
    // 시뮬레이션 이미지 공유를 위한 share Id 생성 하기 실패
    [MAKE_SIMULATION_SHARE_ID_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),

    [INIT_FOREHEAD_SHARE_ID]: (state, { payload: key }) =>
      produce(state, (draft) => {
        draft[key] = initialState[key]; // 초기 상태로 바꾼다
      }),

    // 넓은이마 챌린지 전체 현황 불러오기 성공
    [GET_FOREHEAD_CHALLENGE_SUCCESS]: (state, { payload: result }) => ({
      ...state,
      foreheadChallenge: result,
    }),
    // 넓은이마 챌린지 전체 현황 불러오기 실패
    [GET_FOREHEAD_CHALLENGE_FAILURE]: (state, { payload: error }) => ({
      ...state,
      checkError: error,
    }),

    [INIT_HISTORY]: (state) =>
      produce(state, (draft) => {
        draft['foreheadHistory'] = initialState['foreheadHistory'];
        draft['historyItems'] = initialState['historyItems'];
        draft['historySize'] = initialState['historySize'];
        draft['latestInfo'] = initialState['latestInfo'];
      }),
  },
  initialState,
);

export const getHistoryItems = (state) => state.diagnosis.historyItems;
